import {
  Card,
  Container,
  SimpleGrid,
  Stack,
  Tabs,
  Text,
  Title,
} from "@mantine/core";
import { Breadcrumb } from "../../components/common/Breadcrumb";
import { EducationDegreeDictionary } from "../admin/EducationDegreeDictionary";
import { EducationFacultyDictionary } from "../admin/EducationFacultyDictionary";
import { EducationInstitutionDictionary } from "../admin/EducationInstitutionDictionary";

export function OperationsEducationDictionaries() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <div>
          <Breadcrumb
            items={[
              { label: "Operations Panel", href: "/operations" },
              { label: "Dictionaries", href: "/operations/dictionaries" },
              { label: "Education Dictionaries", isActive: true },
            ]}
          />
          <Title order={1} size="h2" fw={700}>
            Education Dictionaries
          </Title>
          <Text c="dimmed" size="lg">
            Manage all education-related dictionaries in the system
          </Text>
        </div>

        <Tabs defaultValue="degrees">
          <Tabs.List mb="md">
            <Tabs.Tab value="degrees">Degrees</Tabs.Tab>
            <Tabs.Tab value="institutions">Institutions</Tabs.Tab>
            <Tabs.Tab value="faculties">Faculties</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="degrees">
            <EducationDegreeDictionary />
          </Tabs.Panel>

          <Tabs.Panel value="institutions">
            <EducationInstitutionDictionary />
          </Tabs.Panel>

          <Tabs.Panel value="faculties">
            <EducationFacultyDictionary />
          </Tabs.Panel>
        </Tabs>

        <Card withBorder p="lg">
          <Stack gap="md">
            <Title order={3} size="h4">
              About Education Dictionaries
            </Title>
            <Text size="sm" c="dimmed">
              These dictionaries allow you to standardize education-related data
              across the system. You can manage degrees, educational
              institutions, and faculties to ensure consistency in CVs and
              profiles.
            </Text>

            <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="md">
              <Card withBorder p="md" shadow="sm">
                <Title order={4} size="h5">
                  Degrees
                </Title>
                <Text size="sm" c="dimmed">
                  Standardize academic degrees like Bachelor's, Master's, PhD
                </Text>
              </Card>
              <Card withBorder p="md" shadow="sm">
                <Title order={4} size="h5">
                  Institutions
                </Title>
                <Text size="sm" c="dimmed">
                  Manage educational institutions like universities and colleges
                </Text>
              </Card>
              <Card withBorder p="md" shadow="sm">
                <Title order={4} size="h5">
                  Faculties
                </Title>
                <Text size="sm" c="dimmed">
                  Track different faculties and departments within institutions
                </Text>
              </Card>
            </SimpleGrid>
          </Stack>
        </Card>
      </Stack>
    </Container>
  );
}
